import { Fragment, useContext, useState } from "react";
import { StockMovement } from "../../../type/entities/stock-movement-type";
import { menuRoutes } from "../../../router/menu";
import { PrivilegeContext } from "../../../components/priviledge/PriviledgeProvider";
import { FiltersProvider } from "../../../components/providers/FiltersProvider";
import { Button } from "rizzui";
import cn from "../../../utils/classNames";
import PageHeader from "../../../layout/shared/page-header";
import StockMovementsList from "./StockMovementsList";

const StockMovementsListWrapper = () => {

    // STATES

    const [isOpenFormDrawer, setIsOpenFormDrawer] = useState(false);
    const [stockMovementSelected, setStockMovementSelected] = useState<StockMovement | null>(null);

    const breadCrumb = [
        { name: 'Administración' },
        { name: 'Gestión de stock' },
        { name: 'Movimientos de stock', href: menuRoutes.stockMovements.path },
    ];

    const defaultFilters = {};

    // HOOKS
    
    const { userCan } = useContext(PrivilegeContext);

    // RENDER

    return (
        <Fragment>
            <FiltersProvider defaultFilterFilters={defaultFilters}>
                <PageHeader title="Listado de movimientos de stock" breadcrumb={breadCrumb}>
                    {
                        userCan('create', 'stock_movements') &&
                        (
                            <Button
                                color="primary"
                                onClick={() => { 
                                    setIsOpenFormDrawer(true) 
                                    setStockMovementSelected(null)
                                }}
                                className={cn(['mt-4 md:mt-0'])}
                            >
                                Crear movimiento de stock
                            </Button>
                        )
                    }
                </PageHeader>
                <StockMovementsList
                    openFormDrawer={isOpenFormDrawer}
                    setOpenFormDrawer={setIsOpenFormDrawer}
                    stockMovementSelected={stockMovementSelected}
                    setStockMovementSelected={setStockMovementSelected}
                />
            </FiltersProvider>
            
        </Fragment>
    )
}

export default StockMovementsListWrapper;